/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import IdNameVo from './IdNameVo';




  /**
   * The TextbookVersionVo model module.
   * @module textbook/model/TextbookVersionVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TextbookVersionVo</code>.
   * @alias module:textbook/model/TextbookVersionVo
   * @class
   */
  var exports = function() {
    var _this = this;
















  };

  /**
   * Constructs a <code>TextbookVersionVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/TextbookVersionVo} obj Optional instance to populate.
   * @return {module:textbook/model/TextbookVersionVo} The populated <code>TextbookVersionVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'textbookId')) {
        obj['textbookId'] = ApiClient.convertToType(data['textbookId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'submitter')) {
        obj['submitter'] = IdNameVo.constructFromObject(data['submitter']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'auditor')) {
        obj['auditor'] = IdNameVo.constructFromObject(data['auditor']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'auditStatus')) {
        obj['auditStatus'] = ApiClient.convertToType(data['auditStatus'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'auditComment')) {
        obj['auditComment'] = ApiClient.convertToType(data['auditComment'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'auditTime')) {
        obj['auditTime'] = ApiClient.convertToType(data['auditTime'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'withdrawer')) {
        obj['withdrawer'] = IdNameVo.constructFromObject(data['withdrawer']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'withdrawTime')) {
        obj['withdrawTime'] = ApiClient.convertToType(data['withdrawTime'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'releaser')) {
        obj['releaser'] = IdNameVo.constructFromObject(data['releaser']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'onlineStatus')) {
        obj['onlineStatus'] = ApiClient.convertToType(data['onlineStatus'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'releaseTime')) {
        obj['releaseTime'] = ApiClient.convertToType(data['releaseTime'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtCreate')) {
        obj['gmtCreate'] = ApiClient.convertToType(data['gmtCreate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtModified')) {
        obj['gmtModified'] = ApiClient.convertToType(data['gmtModified'], 'Date');
      }
    }
    return obj;
  }

  /**
   * 版本id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 教材id
   * @member {Integer} textbookId
   */
  exports.prototype['textbookId'] = undefined;
  /**
   * 申请发布说明
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 提交者
   * @member {module:textbook/model/IdNameVo} submitter
   */
  exports.prototype['submitter'] = undefined;
  /**
   * 审核者
   * @member {module:textbook/model/IdNameVo} auditor
   */
  exports.prototype['auditor'] = undefined;
  /**
   * 0待审核；1审核通过；-1审核不通过；-2已撤回
   * @member {Integer} auditStatus
   */
  exports.prototype['auditStatus'] = undefined;
  /**
   * 审核意见
   * @member {String} auditComment
   */
  exports.prototype['auditComment'] = undefined;
  /**
   * 审核时间
   * @member {Date} auditTime
   */
  exports.prototype['auditTime'] = undefined;
  /**
   * 撤回着
   * @member {module:textbook/model/IdNameVo} withdrawer
   */
  exports.prototype['withdrawer'] = undefined;
  /**
   * 撤回时间
   * @member {Date} withdrawTime
   */
  exports.prototype['withdrawTime'] = undefined;
  /**
   * 发布着
   * @member {module:textbook/model/IdNameVo} releaser
   */
  exports.prototype['releaser'] = undefined;
  /**
   * 1 当前上线版本，null其他版本，一本书只有一个线上版本
   * @member {Integer} onlineStatus
   */
  exports.prototype['onlineStatus'] = undefined;
  /**
   * 发布下载时间
   * @member {Date} releaseTime
   */
  exports.prototype['releaseTime'] = undefined;
  /**
   * 创建时间
   * @member {Date} gmtCreate
   */
  exports.prototype['gmtCreate'] = undefined;
  /**
   * 更新时间
   * @member {Date} gmtModified
   */
  exports.prototype['gmtModified'] = undefined;



  export default exports;
;


